import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_close-round",
  "use": "icon-svgo_close-round-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-svgo_close-round\"><path d=\"M12.747 5.253a.867.867 0 00-1.224 0l-2.54 2.54-2.44-2.439a.84.84 0 10-1.189 1.19l2.44 2.438-2.541 2.54a.866.866 0 001.224 1.224l2.54-2.54 2.453 2.453a.84.84 0 101.19-1.19l-2.453-2.452 2.54-2.54a.867.867 0 000-1.224M9 17A8 8 0 119 1a8 8 0 010 16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol